export const mockPhotos = [
  {
    id: '1',
    title: 'برج المملكة - الرياض',
    photographer: 'أحمد السعيد',
    city: 'الرياض',
    price: 150,
    views: 1250,
    downloads: 89,
    category: 'cities',
    imageUrl: 'https://public.readdy.ai/ai/img_res/fd1a65303ab0d8d95929cc08e5900e18.jpg',
    previewUrl: 'https://readdy.ai/api/search-image?query=Kingdom%20Tower%20Riyadh%20Saudi%20Arabia%20modern%20architecture%20skyline%20at%20sunset%20with%20golden%20lighting%2C%20professional%20photography%2C%20clean%20background%2C%20high%20quality&width=200&height=150&seq=2&orientation=landscape'
  },
  {
    id: '2',
    title: 'الحرم المكي الشريف',
    photographer: 'فاطمة الزهراني',
    city: 'مكة المكرمة',
    price: 200,
    views: 2100,
    downloads: 156,
    category: 'religious',
    imageUrl: 'https://readdy.ai/api/search-image?query=Masjid%20al-Haram%20Mecca%20Saudi%20Arabia%20holy%20mosque%20with%20Kaaba%2C%20Islamic%20architecture%2C%20pilgrims%2C%20spiritual%20atmosphere%2C%20professional%20photography%2C%20clean%20background&width=400&height=300&seq=3&orientation=landscape',
    previewUrl: 'https://readdy.ai/api/search-image?query=Masjid%20al-Haram%20Mecca%20Saudi%20Arabia%20holy%20mosque%20with%20Kaaba%2C%20Islamic%20architecture%2C%20pilgrims%2C%20spiritual%20atmosphere%2C%20professional%20photography%2C%20clean%20background&width=200&height=150&seq=4&orientation=landscape'
  },
  {
    id: '3',
    title: 'صحراء الربع الخالي',
    photographer: 'محمد العتيبي',
    city: 'الأحساء',
    price: 120,
    views: 890,
    downloads: 67,
    category: 'nature',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20Quarter%20desert%20Saudi%20Arabia%20golden%20sand%20dunes%20at%20sunrise%2C%20vast%20landscape%2C%20natural%20beauty%2C%20professional%20photography%2C%20clean%20background%2C%20dramatic%20lighting&width=400&height=300&seq=5&orientation=landscape',
    previewUrl: 'https://readdy.ai/api/search-image?query=Empty%20Quarter%20desert%20Saudi%20Arabia%20golden%20sand%20dunes%20at%20sunrise%2C%20vast%20landscape%2C%20natural%20beauty%2C%20professional%20photography%2C%20clean%20background%2C%20dramatic%20lighting&width=200&height=150&seq=6&orientation=landscape'
  },
  {
    id: '4',
    title: 'كورنيش جدة',
    photographer: 'سارة الحربي',
    city: 'جدة',
    price: 180,
    views: 1560,
    downloads: 112,
    category: 'cities',
    imageUrl: 'https://readdy.ai/api/search-image?query=Jeddah%20Corniche%20waterfront%20Saudi%20Arabia%20Red%20Sea%20coast%2C%20modern%20buildings%2C%20palm%20trees%2C%20sunset%20reflection%2C%20professional%20photography%2C%20clean%20background&width=400&height=300&seq=7&orientation=landscape',
    previewUrl: 'https://readdy.ai/api/search-image?query=Jeddah%20Corniche%20waterfront%20Saudi%20Arabia%20Red%20Sea%20coast%2C%20modern%20buildings%2C%20palm%20trees%2C%20sunset%20reflection%2C%20professional%20photography%2C%20clean%20background&width=200&height=150&seq=8&orientation=landscape'
  },
  {
    id: '5',
    title: 'قلعة المصمك التاريخية',
    photographer: 'عبدالله النجدي',
    city: 'الرياض',
    price: 160,
    views: 980,
    downloads: 78,
    category: 'religious',
    imageUrl: 'https://readdy.ai/api/search-image?query=Masmak%20Fortress%20Riyadh%20Saudi%20Arabia%20historical%20castle%2C%20traditional%20architecture%2C%20heritage%20site%2C%20professional%20photography%2C%20clean%20background%2C%20golden%20hour%20lighting&width=400&height=300&seq=9&orientation=landscape',
    previewUrl: 'https://readdy.ai/api/search-image?query=Masmak%20Fortress%20Riyadh%20Saudi%20Arabia%20historical%20castle%2C%20traditional%20architecture%2C%20heritage%20site%2C%20professional%20photography%2C%20clean%20background%2C%20golden%20hour%20lighting&width=200&height=150&seq=10&orientation=landscape'
  },
  {
    id: '6',
    title: 'جبال عسير الخضراء',
    photographer: 'نورا الشهري',
    city: 'أبها',
    price: 140,
    views: 1340,
    downloads: 95,
    category: 'nature',
    imageUrl: 'https://readdy.ai/api/search-image?query=Asir%20Mountains%20Saudi%20Arabia%20green%20hills%2C%20misty%20landscape%2C%20natural%20beauty%2C%20professional%20photography%2C%20clean%20background%2C%20dramatic%20clouds&width=400&height=300&seq=11&orientation=landscape',
    previewUrl: 'https://readdy.ai/api/search-image?query=Asir%20Mountains%20Saudi%20Arabia%20green%20hills%2C%20misty%20landscape%2C%20natural%20beauty%2C%20professional%20photography%2C%20clean%20background%2C%20dramatic%20clouds&width=200&height=150&seq=12&orientation=landscape'
  }
];

export const mockVideos = [
  {
    id: 'v1',
    title: 'طيران فوق الرياض',
    photographer: 'خالد الدوسري',
    city: 'الرياض',
    price: 300,
    views: 2200,
    downloads: 145,
    category: 'cities',
    duration: '2:30',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Riyadh%20Saudi%20Arabia%20cityscape%2C%20modern%20skyscrapers%2C%20urban%20development%2C%20professional%20videography%2C%20clean%20background%2C%20cinematic%20quality&width=400&height=300&seq=13&orientation=landscape'
  },
  {
    id: 'v2',
    title: 'غروب في العلا',
    photographer: 'ريم القحطاني',
    city: 'العلا',
    price: 250,
    views: 1890,
    downloads: 98,
    category: 'nature',
    duration: '1:45',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=AlUla%20Saudi%20Arabia%20sunset%20over%20ancient%20rock%20formations%2C%20desert%20landscape%2C%20golden%20hour%2C%20professional%20videography%2C%20clean%20background%2C%20cinematic%20quality&width=400&height=300&seq=14&orientation=landscape'
  }
];

export const mockCategories = [
  {
    id: 'photos',
    name: 'صور فوتوغرافية',
    icon: 'ri-camera-line',
    count: 1250
  },
  {
    id: 'videos',
    name: 'مقاطع فيديو',
    icon: 'ri-video-line',
    count: 340
  },
  {
    id: 'nature',
    name: 'مشاهد طبيعية',
    icon: 'ri-landscape-line',
    count: 890
  },
  {
    id: 'religious',
    name: 'معالم دينية',
    icon: 'ri-building-line',
    count: 456
  },
  {
    id: 'cities',
    name: 'مدن سعودية',
    icon: 'ri-building-2-line',
    count: 678
  }
];

export const mockUser = {
  id: '1',
  name: 'أحمد محمد',
  email: 'ahmed@example.com',
  phone: '+966501234567',
  purchases: ['1', '3', 'v1'],
  favorites: ['2', '4', 'v2']
};